<template>
  <modal-wrap
    :id="modalName"
    :name="modalName"
    :header-class="'border-0 service-level-header'"
    :body-class="'service-level-modal assignment-form'"
    :hide-footer="false"
    size="md"
  >
    <template #modal-title>
      <h4 class="mb-0">Select file</h4>
    </template>
    <template #default>
      <div class="col-12">
        <div class="form-group">
          <div class="input-group">
            <div class="select-file">
              <input id="file" type="file" accept=".csv,.xlsx,.xls,.txt" @change="fileSelected($event)" />
              <div v-if="file && file.name">
                <span>{{ file.name }}</span>
              </div>
              <div v-else><span>Choose file</span> or drop file here</div>
            </div>
          </div>
          <div v-if="errors.length" class="text-danger">
            <b>Error: </b>
            <span v-for="(error, key) in errors" :key="key">{{ error }}</span>
          </div>
        </div>
      </div>
      <div class="form-check">
        <input
          id="replace"
          v-model="replace"
          :value="true"
          type="checkbox"
          class="form-check-input"
          name="sendNotifications"
        />
        <label class="form-check-label" for="replace"> Replace existing file and all items with new file </label>
      </div>
    </template>
    <template #modal-footer>
      <b-button size="md" class="btn-grey mr-3" @click="uploadFile">Upload file</b-button>
    </template>
  </modal-wrap>
</template>

<script lang="ts">
import type { UploadFile } from '@/types/Components/UploadFile'
import { notify } from '@kyvg/vue3-notification'
import { BButton } from 'bootstrap-vue-next'
import { defineComponent, computed, onMounted, ref, type Ref } from 'vue'
import { ATTACH_SOURCE_FILE_MODAL } from '@/const/ModalTypes'
import { registerModals } from '@/services/Modal'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useVueNextModalStore } from '@/store/vueNextModal'
import ModalWrap from '@/views/Modals/ModalWrap.vue'
import AssignmentProxy from '@/proxies/AssignmentProxy'

export default defineComponent({
  name: 'AttachSourceFileModal',
  components: { BButton, ModalWrap },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const modalStore = useVueNextModalStore()

    const modalName = ATTACH_SOURCE_FILE_MODAL
    const errors: Ref<string[]> = ref([])
    const replace = ref(false)
    const file: Ref<UploadFile> = ref({ name: '', file: null })

    const assignmentRef = computed(() => assignmentSummaryStore.reference || '')
    const proxy = new AssignmentProxy()

    const uploadFile = () => {
      const formData = new FormData()

      if (file.value.file) {
        formData.append('file', file.value.file)
      }

      formData.append('replace', replace.value ? '1' : '0')

      errors.value = []
      proxy
        .attachSourceFile(assignmentRef.value, formData)
        .then(() => {
          modalStore.closeModal(modalName)
          notify({
            type: 'success',
            text: 'File uploaded successfully',
          })
        })
        .catch((error) => {
          Object.keys(error.errors).forEach((key) => {
            errors.value.push(error.errors[key].join(', '))
          })
        })
    }

    const fileSelected = (event: any) => {
      const selectedFile = event.target.files[0]
      file.value = { name: selectedFile.name, file: selectedFile }
    }

    onMounted(() => {
      registerModals(modalName)
    })

    return {
      file,
      errors,
      replace,
      modalName,
      uploadFile,
      fileSelected,
    }
  },
})
</script>
